import { ApiMananger } from "actions/rtkquery";
import { PIECES_COMPTABLES_API_ROUTE, RATTACHER_PIECE_API_ROUTE } from "routes/api/endpoints";
import { INVALIDATE_PIECES } from "./queries";
import {
  INVALIDATE_DEPENSES,
  INVALIDATE_VENTES,
  INVALIDATE_TRANSACTIONS,
  INVALIDATE_ECRITURE,
  INVALIDATE_LIVRE_JOURNAL,
} from "actions/invalidationTags";

const piecesMutations = ApiMananger.injectEndpoints({
  endpoints: (build) => ({
    comptabiliserPiece: build.mutation({
      query: ({ piece_id, dossier_id }) => ({
        url: `${PIECES_COMPTABLES_API_ROUTE}${piece_id}/`,
        method: "POST",
        body: { action: "comptabiliser", dossier_id },
      }),
      invalidatesTags: [INVALIDATE_PIECES],
    }),

    createPieceComptable: build.mutation({
      query: (formData) => ({
        url: PIECES_COMPTABLES_API_ROUTE,
        method: "POST",
        body: formData,
      }),
      invalidatesTags: [
        INVALIDATE_PIECES,
        INVALIDATE_DEPENSES,
        INVALIDATE_VENTES,
        INVALIDATE_TRANSACTIONS,
        INVALIDATE_ECRITURE,
        INVALIDATE_LIVRE_JOURNAL,
      ],
    }),

    updatePieceComptable: build.mutation({
      query: ({ id, ...body }) => ({
        url: `${PIECES_COMPTABLES_API_ROUTE}${id}/`,
        method: "PATCH",
        body,
      }),
      invalidatesTags: [
        INVALIDATE_PIECES,
        INVALIDATE_DEPENSES,
        INVALIDATE_VENTES,
        INVALIDATE_TRANSACTIONS,
        INVALIDATE_ECRITURE,
      ],
    }),

    deletePieceComptable: build.mutation({
      query: ({ id }) => ({
        url: `${PIECES_COMPTABLES_API_ROUTE}${id}/`,
        method: "DELETE",
      }),
      invalidatesTags: [
        INVALIDATE_PIECES,
        INVALIDATE_DEPENSES,
        INVALIDATE_VENTES,
        INVALIDATE_TRANSACTIONS,
        INVALIDATE_ECRITURE,
      ],
    }),

    rattacherPiece: build.mutation({
      query: (body) => ({
        url: RATTACHER_PIECE_API_ROUTE,
        method: "POST",
        body: { ...body, action: "rattacher" },
      }),
      invalidatesTags: [
        INVALIDATE_PIECES,
        INVALIDATE_DEPENSES,
        INVALIDATE_VENTES,
        INVALIDATE_TRANSACTIONS,
        INVALIDATE_ECRITURE,
      ],
    }),

    detacherPiece: build.mutation({
      query: (body) => ({
        url: RATTACHER_PIECE_API_ROUTE,
        method: "POST",
        body: { ...body, action: "detacher" },
      }),
      invalidatesTags: [
        INVALIDATE_PIECES,
        INVALIDATE_DEPENSES,
        INVALIDATE_VENTES,
        INVALIDATE_TRANSACTIONS,
        INVALIDATE_ECRITURE,
      ],
    }),

    // -------------------------------------------------------------------
    // OCR -> Proposition d'ecritures comptables (CECA, taux cible 95-97%)
    // MVP : le moteur propose, l'utilisateur corrige puis valide.
    // -------------------------------------------------------------------
    proposerEcriturePiece: build.mutation({
      query: ({ piece_id, dossier_id }) => ({
        url: `${PIECES_COMPTABLES_API_ROUTE}${piece_id}/proposer-ecriture/`,
        method: "POST",
        body: { dossier_id },
      }),
    }),

    validerEcriturePiece: build.mutation({
      query: ({
        piece_id,
        dossier_id,
        libelle,
        date_ecriture,
        journal_type,
        lignes,
      }) => ({
        url: `${PIECES_COMPTABLES_API_ROUTE}${piece_id}/valider-ecriture/`,
        method: "POST",
        body: {
          dossier_id,
          libelle,
          date_ecriture,
          journal_type,
          lignes,
        },
      }),
      invalidatesTags: [
        INVALIDATE_PIECES,
        INVALIDATE_DEPENSES,
        INVALIDATE_VENTES,
        INVALIDATE_TRANSACTIONS,
        INVALIDATE_ECRITURE,
        INVALIDATE_LIVRE_JOURNAL,
      ],
    }),
  }),
  overrideExisting: false,
});

export const {
  useComptabiliserPieceMutation,
  useCreatePieceComptableMutation,
  useUpdatePieceComptableMutation,
  useDeletePieceComptableMutation,
  useRattacherPieceMutation,
  useDetacherPieceMutation,
  useProposerEcriturePieceMutation,
  useValiderEcriturePieceMutation,
} = piecesMutations;
